'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.constantStaging
 * @description
 * # constantStaging
 * Constant in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .constant('appSettings', {
    appName: 'Schedule Manager',
    appVersion: '0.1',
    api: {
      baseUrl: '${GREENFROG_API_URL}/',
      version: 'v1'
    },
    firebase: {
      apiKey: 'AIzaSyAMkVqYmFi4o5LQ_OJOqcubaA2tivZjZZk',
      authDomain: 'greenfrog-e3a6c.firebaseapp.com',
      databaseURL: 'https://greenfrog-e3a6c.firebaseio.com',
      storageBucket: 'greenfrog-e3a6c.appspot.com'
    },
    google: {
      recaptcha: {
        siteKey: '6Le7siMUAAAAAJzJZfJeL89yeWSfkEJ9tS_f_VLK'
      },
      geocode: {
        baseUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
        apiKey: 'AIzaSyDGpQbCNpVoBit07TKpGyZUvvCI5IDC4jA'
      }
    },
    postcodes: {
      baseUrl: 'https://api.postcodes.io'
    },
    sentry: {
      DSN: 'https://18f600beb7c64f85854457c7b3f1acf1@sentry.io/4950935',
      environment: '${GREENFROG_ENVIRONMENT}'
    }
  });
